import PrintAssetCreate from './PrintAssetCreate';

export default PrintAssetCreate;
